import { Component, Input } from '@angular/core';

export interface ReportColumn {
  key: string;
  header: string;
  type?: 'text' | 'badge' | 'score' | 'avatar';
  /** Numeric/value column — right-aligned, muted styling. */
  value?: boolean;
  render?: (row: any) => string;
  badgeClass?: (row: any) => string;
  badgeLabel?: (row: any) => string;
  scoreValue?: (row: any) => number;
  avatarName?: (row: any) => string;
  avatarImage?: (row: any) => string;
  avatarVariant?: 'driver' | 'cooperate';
}

@Component({
  selector: 'app-br-data-table',
  templateUrl: './data-table.component.html'
})
export class BrDataTableComponent {
  @Input() columns: ReportColumn[] = [];
  @Input() rows: any[] = [];
  @Input() emptyMessage = 'No data';
  /** When true, sums numeric value columns and renders a footer row. */
  @Input() showTotals = false;

  get hasTotals(): boolean {
    return this.showTotals && this.rows && this.rows.length > 0;
  }

  totalForColumn(col: ReportColumn): string {
    if (!col.value) return '';
    const sum = this.rows.reduce((acc, row) => acc + (Number(row[col.key]) || 0), 0);
    if (col.render) {
      return col.render({ [col.key]: sum });
    }
    return String(sum);
  }

  cellText(col: ReportColumn, row: any): string {
    if (col.render) return col.render(row);
    const value = row[col.key];
    return value === null || value === undefined || value === '' ? '—' : value;
  }

  scoreClass(score: number): string {
    if (score >= 90) return 'good';
    if (score >= 75) return 'ok';
    if (score >= 60) return 'warn';
    return 'bad';
  }
}
